import { Button, Typography } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import React from "react";

export default function ({ title, description, extra }) {
  return (
    <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
      <div>
        <Typography.Title level={3} style={{ marginBottom: 0, marginTop: 8 }}>
          {title}
        </Typography.Title>
        <Typography.Text type="secondary">{description}</Typography.Text>
      </div>
      <div style={{ flex: 1, textAlign: "right" }}>{extra}</div>
    </div>
  );
}
